import profile from "./sihphto3.jpeg";
import  Homeicon from "./home.svg"
import tick from './tick.png'
import warning from './warning.png' 
import clock from './clock.png'
import lightning from './lightning.png'
import fire from './fire.png'

const images = {
  profile,
  Homeicon,
  tick,
  clock,
  warning,
  fire ,
  lightning
};
export default images;

